import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {makeStyles} from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import {
    BookmarkLink,
    BookmarkLinkGroup,
    usePreferencesState
} from '@tracker/shared/src/Preferences/PreferencesProvider';
import PersonalSchedule from '@tracker/shared/src/Scheduling/PersonalSchedule';
import React, {useMemo, useState} from 'react';
import DefaultView from './DefaultView';
import EditView from './EditView';
import Utilization from './Utilization';

const useStyles = makeStyles(theme => ({
    switch: {
        marginTop: theme.spacing(2),
    },
    scheduleContainer: {
        marginTop: theme.spacing(2),
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
}));

export type BookmarkLinkWithId = BookmarkLink & { id : number };
export type BookmarkLinkGroupWithId = Omit<BookmarkLinkGroup, 'links'> & {
    id : number;
    links : BookmarkLinkWithId[];
};

let currentLinkIdId = 1;
export const linkIdGenerator = () : number => currentLinkIdId++;

const Home : React.FC = () => {
    const classes = useStyles();
    const {preferences} = usePreferencesState();
    const [inEditMode, setInEditMode] = useState(false);

    const linkGroups = useMemo(() => preferences.dashboard.linkGroups.map(linkGroup => ({
        ...linkGroup,
        id: linkIdGenerator(),
        links: linkGroup.links.map(link => ({
            ...link,
            id: linkIdGenerator(),
        })),
    })), [preferences.dashboard.linkGroups]);

    return (
        <>
            {inEditMode ? (
                <EditView linkGroups={linkGroups}/>
            ) : (
                <DefaultView linkGroups={linkGroups}/>
            )}

            <FormControlLabel
                control={
                    <Switch
                        color="primary"
                        checked={inEditMode}
                        onChange={event => setInEditMode(event.target.checked)}
                    />
                }
                label="Edit Bookmarks"
                className={classes.switch}
            />

            <Divider className={classes.divider}/>
            <Utilization/>

            <div className={classes.scheduleContainer}>
                <PersonalSchedule/>
            </div>
        </>
    );
};

export default Home;
